<template>
    <span class="base-timer label">
        {{ formattedTimeLeft }}
    </span>
</template>

<script>

export default {
  data () {
    return {
    }
  },

  props: [
    'timeLeft'
  ],

  methods: {
  },

  watch: {
  },

  mounted () {
  },

  beforeDestroy () {
  },

  computed: {
    formattedTimeLeft () {
      const timeLeft = this.timeLeft
      // The largest round integer less than or equal to the result of time divided being by 60.
      // const minutes = Math.floor(timeLeft / 60)
      // Seconds are the remainder of the time divided by 60 (modulus operator)
      let seconds = timeLeft % 60
      // If the value of seconds is less than 10, then display seconds with a leading zero
      if (seconds < 10) {
        seconds = `0${seconds}`
      }
      // The output in MM:SS format
      // return `${minutes}:${seconds}`
      return `${seconds}`
    },
    timeFraction () {
      // Divides time left by the defined time limit.
      return this.timeLeft / this.timeLimit
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzTimer.vue